import { useState, useEffect } from 'react';

// Direction B "Stream" multi-device breakpoints (see
// docs/direction-b-multidevice-plan.md). The phone layout is the shipped,
// single-column design; tablet/desktop compose the same Lobby + ChatThread
// components into panes.
//   phone   : < 768px  — single Today stream (Lobby OR ChatThread swap)
//   tablet  : 768–1179 — two-pane (Today + detail)
//   desktop : >= 1180  — three-pane (Today + thread + Work rail)
export const BP_TABLET = 768;
export const BP_DESKTOP = 1180;

export function classifyWidth(width) {
  if (width >= BP_DESKTOP) return 'desktop';
  if (width >= BP_TABLET) return 'tablet';
  return 'phone';
}

// Returns the current breakpoint bucket, updating on resize. SSR-safe: falls
// back to 'phone' (the safety-net layout) when there's no window.
export default function useBreakpoint() {
  const [bp, setBp] = useState(() =>
    typeof window === 'undefined' ? 'phone' : classifyWidth(window.innerWidth),
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => setBp(classifyWidth(window.innerWidth));
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}
